import React from 'react';
import ShortListPopupIcon from '../../Images/ShortListPopupIcon.svg';

function ShortListPopup({ close, SecondModel, ScheduleInterviewLater1,handleShortListCandidate }) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '420px',
        height: 'auto',
        maxHeight: '300px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '20px',
        border: '1px solid #E7E7E7',
        backgroundColor: 'white',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Lexend, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '24px',
        boxSizing: 'border-box',
      }}
    >
    
      <div style={{ textAlign: 'center' }}>
        <img
          src={ShortListPopupIcon}
          alt="Shortlist Icon"
          style={{ width: '48px', height: '50px',color:'#4DB53A' }}
        />
      </div>

   
      <div
        style={{
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: '500',
          color: '#242424',
          lineHeight:'18.23px',
          marginTop: '16px',
        }}
      >
        Schedule the Interview round for selected candidate
      </div>

    
      <div
        style={{
          display: 'flex',
          gap: '12px',
          marginTop: '24px',
        }}
      >
      
        <button
          onClick={SecondModel}
          style={{
            width: '180px',
            height: '40px',
            backgroundColor: '#3C78D8',
            color: 'white',
            borderRadius: '8px',
            border: 'none',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
          }}
        >
          Schedule Interview Now
        </button>

        <button
          onClick={ScheduleInterviewLater1}
          style={{
            width: '180px',
            height: '40px',
            backgroundColor: 'white',
            color: '#3C78D8',
            border: '1px solid #3C78D8',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
          }}
        >
          Schedule Later
        </button>
      </div>
    </div>
  );
}

export default ShortListPopup;
